// For convenience, standardizing imports, and easy refactoring
import DefaultLocale from 'dayjs/locale/en-ca';
export { DefaultLocale };
